var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTreeAlt3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 2C14.2091 2 16 3.79086 16 6C18.2091 6 20 7.79086 20 10C20 10.4929 19.9108 10.965 19.7478 11.401C21.0811 12.0497 22 13.4176 22 15C22 17.2091 20.2091 19 18 19H12.75V17.8107L14.0303 16.5303C14.3232 16.2374 14.3232 15.7626 14.0303 15.4697C13.7374 15.1768 13.2626 15.1768 12.9697 15.4697L12.75 15.6893V14.8107L14.0303 13.5303C14.3232 13.2374 14.3232 12.7626 14.0303 12.4697C13.7374 12.1768 13.2626 12.1768 12.9697 12.4697L12.75 12.6893V11C12.75 10.5858 12.4142 10.25 12 10.25C11.5858 10.25 11.25 10.5858 11.25 11V14.1893L11.0303 13.9697C10.7374 13.6768 10.2626 13.6768 9.96967 13.9697C9.67678 14.2626 9.67678 14.7374 9.96967 15.0303L11.25 16.3107V19H6C3.79086 19 2 17.2091 2 15C2 13.4176 2.91891 12.0497 4.25223 11.401C4.08916 10.965 4 10.4929 4 10C4 7.79086 5.79086 6 8 6C8 3.79086 9.79086 2 12 2Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.25 21.25V19H12.75V21.25H14C14.4142 21.25 14.75 21.5858 14.75 22C14.75 22.4142 14.4142 22.75 14 22.75H10C9.58579 22.75 9.25 22.4142 9.25 22C9.25 21.5858 9.58579 21.25 10 21.25H11.25Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTreeAlt3);
export default __webpack_public_path__ + "static/media/tree-alt-3.9a30ba84e123a17c6278084c9d66d57d.svg";
export { ForwardRef as ReactComponent };